import { FormInput, InterestProvidersListFiltersFormFields } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { IntlShape } from 'react-intl/src/types';

export const useInterestProvidersListFiltersFormFields = (intl: IntlShape) => {
  const interestProvidersListFiltersFormFields: Record<
    keyof InterestProvidersListFiltersFormFields,
    FormInput
  > = {
    mortgageType: {
      fieldName: 'mortgageType',
      label: intl.formatMessage({ id: 'filters.mortgageType', defaultMessage: 'Hypotheekvorm' }),
      type: 'select',
      defaultValue: getDefaultValue('Aflossingsvrije_hypotheek')
    },
    mortgageTerm: {
      fieldName: 'mortgageTerm',
      label: intl.formatMessage({
        id: 'filters.mortgageTerm',
        defaultMessage: 'Rentevaste periode'
      }),
      type: 'select',
      options: [
        {
          label: intl.formatMessage({
            id: 'filters.mortgageTerm.variable',
            defaultMessage: 'Variabel'
          }),
          value: '0'
        },
        {
          label: intl.formatMessage(
            {
              id: 'filters.mortgageTerm.year',
              defaultMessage: '{int} year'
            },
            { int: 1 }
          ),
          value: '1'
        },
        {
          label: intl.formatMessage(
            {
              id: 'filters.mortgageTerm.year',
              defaultMessage: '{int} year'
            },
            { int: 5 }
          ),
          value: '5'
        },
        {
          label: intl.formatMessage(
            {
              id: 'filters.mortgageTerm.year',
              defaultMessage: '{int} year'
            },
            { int: 6 }
          ),
          value: '6'
        },
        {
          label: intl.formatMessage(
            {
              id: 'filters.mortgageTerm.year',
              defaultMessage: '{int} year'
            },
            { int: 7 }
          ),
          value: '7'
        },
        {
          label: intl.formatMessage(
            {
              id: 'filters.mortgageTerm.year',
              defaultMessage: '{int} year'
            },
            { int: 10 }
          ),
          value: '10'
        },
        {
          label: intl.formatMessage(
            {
              id: 'filters.mortgageTerm.year',
              defaultMessage: '{int} year'
            },
            { int: 15 }
          ),
          value: '15'
        },
        {
          label: intl.formatMessage(
            {
              id: 'filters.mortgageTerm.year',
              defaultMessage: '{int} year'
            },
            { int: 20 }
          ),
          value: '20'
        },
        {
          label: intl.formatMessage(
            {
              id: 'filters.mortgageTerm.year',
              defaultMessage: '{int} year'
            },
            { int: 30 }
          ),
          value: '30'
        }
      ],
      defaultValue: getDefaultValue('10', true)
    },
    interestTariff: {
      fieldName: 'interestTariff',
      label: intl.formatMessage({ id: 'filters.interestTariff', defaultMessage: 'Rentetarief' }),
      type: 'select',
      options: [
        { label: ' NHG', value: '0' },
        { label: ' &#8804; 50%', value: '50' },
        { label: '51% &#8804; 60%', value: '60' },
        { label: '61% &#8804; 70%', value: '70' },
        { label: '71% &#8804; 80%', value: '80' },
        { label: '81% &#8804; 90%', value: '90' },
        { label: '91% &#8804; 100%', value: '100' },
        { label: '&gt; 100%', value: '106' }
      ],

      defaultValue: getDefaultValue('0', true)
    },
    buildingType: {
      fieldName: 'buildingType',
      label: intl.formatMessage({ id: 'filters.buildingType', defaultMessage: 'Type bouw' }),
      type: 'select',
      options: [
        {
          label: intl.formatMessage({
            id: 'filters.buildingType.existing',
            defaultMessage: 'Bestaande bouw'
          }),
          value: 'Bestaande_bouw'
        },
        {
          label: intl.formatMessage({
            id: 'filters.buildingType.new',
            defaultMessage: 'Nieuwbouw'
          }),
          value: 'Nieuwbouw'
        }
      ],
      defaultValue: getDefaultValue('Bestaande_bouw', true)
    },
    energyLabel: {
      fieldName: 'energyLabel',
      label: intl.formatMessage({
        id: 'filters.energyLabel',
        defaultMessage: 'Energielabel'
      }),
      type: 'select',
      options: [
        { value: 'APPPP', label: 'A++++ incl. EPG' },
        { value: 'APPPP', label: 'A++++' },
        { value: 'APPP', label: 'A+++' },
        { value: 'APP', label: 'A++' },
        { value: 'AP', label: 'A+' },
        { value: 'A', label: 'A' },
        { value: 'B', label: 'B' },
        { value: 'C', label: 'C' },
        { value: 'D', label: 'D' },
        { value: 'E', label: 'E' },
        { value: 'F', label: 'F' },
        { value: 'G', label: 'G' },
        { value: '', label: `${intl.locale === 'en' ? 'No label' : 'Geen label'}` }
      ],
      defaultValue: getDefaultValue('', true)
    }
  };
  return interestProvidersListFiltersFormFields;
};
